
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqIi4607YRO8JRvoCVZyyXmvEk4yz9eIe4F3QjKMYsRzMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/faq.vue?macro=true";
import { default as clubl9N2teVbuH_45E8epXe1PJf2Fx_dWiUVItNzxzpELPJWQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/club.vue?macro=true";
import { default as homevbKLDW5Qkc3IPBXLtXapxxiM_54P_eNcPzdYcVX_B1oMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/home.vue?macro=true";
import { default as aboutY9OJAxGp5DmvgTfgMQyvfqb_wyVDsn_h_450s0EtPip9MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/about.vue?macro=true";
import { default as indexwOiwNCbz8f7LKmeXVqJWqtSVdg8IIKzcGc2rKlxr4QUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/index.vue?macro=true";
import { default as termsPmjyHvBYkC2vsE4xWjz0f0cVjKiLBETYLTS3_45PSLKqkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/terms.vue?macro=true";
import { default as latestZ2aUVQ_QdWNY0sF0Gw92rHTO_45zIWcUtZvHxk2lIA0XUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/latest.vue?macro=true";
import { default as searchaMkCqsEBb_45AwfB5Gy48lnkjvhAoRfHvr3SOLZ_45bTHdIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/search.vue?macro=true";
import { default as _91id_93Md0biizdh53ifvp8pK0RF5l1c_82uoRsv_45btYCljiSAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/ppv/[id].vue?macro=true";
import { default as indexEMXBo0OEhAgdLorjEw3x4MKLx0mpxl6_3wg4YyYrZ4IMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/ppv/index.vue?macro=true";
import { default as ppvvAVPYxrfGfKT_45WnpuDmmVim38FlU6X7cVCd4pF94Bh8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/ppv.vue?macro=true";
import { default as indexpSCWsvuOzs26Osd9z_pUH4RDe5EAF6Ca3ao957oCsW8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/index.vue?macro=true";
import { default as indexDqGR35d5ohIPPWhipKyZNj_N6AaZZfuJLibx3cjUMwEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/billing/index.vue?macro=true";
import { default as billingeme07d8f4Z5T74z7ymnIl7UrgrQA0iytrJQ1yW2ZAMcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/billing.vue?macro=true";
import { default as devicesafyLXN4WLIe8hWhBC0IVa3pXdCbWDzbQo6f1hC3poLwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/devices.vue?macro=true";
import { default as general1PzOPjVM9MtEvLextFf_45csDCyxu9dE67WN9JZcUprk4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/general.vue?macro=true";
import { default as password2g_457YnjL_7umB_45R3W0SubyQVXpuPNeEvFRmfvJFQU1MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/password.vue?macro=true";
import { default as _91id_93YY_rbK5I7P7NvuzR2Vb1GNv5HjjcsVDDAQFX_45K9pBIEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription/[id].vue?macro=true";
import { default as indexhfOCAmojLMGGnPtR_45_24kq6DDRaaMG_45XyjHQw_8coi4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription/index.vue?macro=true";
import { default as _91id_93B0k7YUrRFrThctQ7FDFSxj1Q5xEOArTrtW_452dVMWI7YMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription/buy/[id].vue?macro=true";
import { default as subscriptionGaly_MyYBxd8ZlSbz0VWyRDUHA_yFnaQhZyvev7NTVMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription.vue?macro=true";
import { default as accountYlzrdJAq4_u_45LRM6MHQPiDY8c1CgU1R7PJYr9v9srigMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account.vue?macro=true";
import { default as archiveybcfurk04AlrEfYkm7BoVT0ogvdtXMKHlXxv5Gc_arwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/archive.vue?macro=true";
import { default as privacyhUUwT3SLt8vIFICF09gkn3ddlg3SZjy14WEyufeC08cMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/privacy.vue?macro=true";
import { default as open_45appjc7chybuT3tdYsq7zVzP0dSzfEzdtUw7GBOUTsC__450MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/open-app.vue?macro=true";
import { default as upcomingI7y02yyAW5xxyWt_45KbLRNmtsxVEUO5ngwMi8jS4IYp8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/upcoming.vue?macro=true";
import { default as highlighteQPkuUfZcw_45_iKs7HbXLgR_GAp8uZuK5WF58kCIEStkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/highlight.vue?macro=true";
import { default as suggestedQWmMq3wjR4JCSDFiNAdbtnq6sYGg9nfsHZYdQs_45Vg40Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/suggested.vue?macro=true";
import { default as indexgGBIGDDpg_451KtId0IjG0xYgRwZX_Yt1_KCxtPeXfrIYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/live/index.vue?macro=true";
import { default as _91type_93yEk7ja_458HCmypghZ1z7BTXSY0oTF4Q_45iNdvEAt86E9UMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/info/[type].vue?macro=true";
import { default as _91teamId_93z2ALl1JeX_45RNAebB9QjkhHsX_45yvEaQ17_45tA_6YdSiOkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/team/[teamId].vue?macro=true";
import { default as recommendationSUavnlMFHQSYvC9jpqi_45lDmVdaiXGV1e09tr5ssnNvwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/recommendation.vue?macro=true";
import { default as clipsaQvFktAVHbhbmLSw50B5Ks2MPSPmJlzaNz53JXqM3sEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/selected/clips.vue?macro=true";
import { default as indexpaMUk_45DgGCHtOUn2puyhaveKwmrJ0XK18i0gWYM945EMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/index.vue?macro=true";
import { default as failureHXkteBEU8iKKgSmcqA_457H_yYDjSIdy_1KyFsAtrckpgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/payment/failure.vue?macro=true";
import { default as successJckSAJ42KrsKQ32vQ1whAqn78EswcczFfrYTEpE0llYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/payment/success.vue?macro=true";
import { default as videosLvMruMnO3IMQl_Ik2pYlr1pNbPew7JPCtUl0d23xLVwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/selected/videos.vue?macro=true";
import { default as indexoHrmyWqiYOEgPg28IPhRSLUbzStIUTpNbzJXU0yxT1cMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/login/index.vue?macro=true";
import { default as limitcmYGBoFIXpZP9mATKa22SrYQixGarD8l0rZZbmMMNokMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/login/limit.vue?macro=true";
import { default as _91eventId_93Mh92EJ5mOR6mv2iUVg1aEgGvNlCe7jedPZJ87aw6wiwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/events/[eventId].vue?macro=true";
import { default as indexDKktIb5dFfR_45O_2xVi0c30gyisTXO6zFdHPBXSQ_WooMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/live/[sportType]/index.vue?macro=true";
import { default as _91sportType_93bps4msXZit4px08dk4UEwLmEo66W6OFEZmVeyDpLRFsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/live/[sportType].vue?macro=true";
import { default as _91leagueId_93nWmEjZ78OM8lylJOl_7z5e0mOu_8zGd7DukBNyfg_453YMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/league/[leagueId].vue?macro=true";
import { default as indexVOj7fRgcKUOFog2k3O0iiJk29kkdglN8vyfUx_7NAi0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/index.vue?macro=true";
import { default as _91eventId_93fPANqZKisISQcg7mjavWM9Vd_FLHhu4_0V7emQhdR88Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/channels/[eventId].vue?macro=true";
import { default as processingpDMlBrQIdZsAN69rhFxswDUINYsHbZCUtDP5Q_wxaIcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/payment/processing.vue?macro=true";
import { default as resetWKDSQrBb81cc74zcO8Tdpdsmt8QjpuBuMiZU28LdPoMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/password/reset.vue?macro=true";
import { default as forgotIXHPfAy9EO2pKe_45KQ7L35wTVQB_45MwdVBKdBS6DRg_1YMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/password/forgot.vue?macro=true";
import { default as _91eventId_93nQr68YgI3GB_45rveKU6UdBnm_45HVyfsVrNd3W7DjEMgCkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/events/stats/[eventId].vue?macro=true";
import { default as indexXsPAzqpvZL50CPt_nwvRJnZbbxFMZjl66TBYLLtIdBoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/index.vue?macro=true";
import { default as indexIwU9d9EwJsxWWYj6X9VarFpBpAgLDoVDPLZZX9w_45hcUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/category/[mainId]/index.vue?macro=true";
import { default as indexo5OZdZaJJxGmQ8FDJretkRlWUoaaNpXGeqS4f8IcktkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/index.vue?macro=true";
import { default as followedfY3zva3fcFQSAWi5Izuubkzvf8bJtxcb2RbAhMWOmIIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/followed.vue?macro=true";
import { default as followedydpfaSoypEQ_2_45AA9It3Srdq_453p9wGHK8BtQfnUgSHcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/followed.vue?macro=true";
import { default as personalizationUTfceHIHg4y6NyknPI8OPEHcXRvldP3aoBz_QqjsbC0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/personalization.vue?macro=true";
import { default as _91referenceId_93YTIb7opFnYckSchOoDNlVxkPu_45wvMKqc9nCrCG6uTzUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/redirect/events/[referenceId].vue?macro=true";
import { default as _91provider_93xqS_45L9dpAhfwcTzCqoDCKE2g65nUT5qaQjy4W6ekn5gMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/oauth2/callback/[provider].vue?macro=true";
import { default as indexOAiNOLumTdwx6jm26J5k1UgGDx0FAuWyVo9y8ErIATAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/subscription/index.vue?macro=true";
import { default as indexEuV1SkeGDfouKtDEEWrY5WXAuhsPnJcFV6zhXXbMFxMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/[mainId]/index.vue?macro=true";
import { default as index8OMeNDb_45ldantlTDDKdnzhXx41g2jBy6xC4hh038bsAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/[leagueId]/index.vue?macro=true";
import { default as _91id_93qvZMjgMVONvurtH7KRGNnhH7FYiHe6SdYBrxIy5ho1sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/subscription/buy/[id].vue?macro=true";
import { default as indexhNublU9J_sInTYBqO4mUzEvT_KRvzwwMa_eCgWQMkrYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/subscription/code/index.vue?macro=true";
import { default as followedO9GwW6CyzTUjOXoJnucwKCqzk4AESlHAHJxHs4Jy7K8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/[mainId]/followed.vue?macro=true";
import { default as followedMA7Sth5zBsD4VGmrH2x3oucOu8SNDluZya5x4u7TyfoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/[leagueId]/followed.vue?macro=true";
import { default as _91subId_93aRCRBdrgekStpVNvf4OIjFD0q7ziHw8Ec05vIlxM7cYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/pages/category/[mainId]/sub-category/[subId].vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faqIi4607YRO8JRvoCVZyyXmvEk4yz9eIe4F3QjKMYsRzMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/faq.vue")
  },
  {
    name: "club",
    path: "/club",
    meta: clubl9N2teVbuH_45E8epXe1PJf2Fx_dWiUVItNzxzpELPJWQMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/club.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/home.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutY9OJAxGp5DmvgTfgMQyvfqb_wyVDsn_h_450s0EtPip9MMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexwOiwNCbz8f7LKmeXVqJWqtSVdg8IIKzcGc2rKlxr4QUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsPmjyHvBYkC2vsE4xWjz0f0cVjKiLBETYLTS3_45PSLKqkMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/terms.vue")
  },
  {
    name: "latest",
    path: "/latest",
    meta: latestZ2aUVQ_QdWNY0sF0Gw92rHTO_45zIWcUtZvHxk2lIA0XUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/latest.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchaMkCqsEBb_45AwfB5Gy48lnkjvhAoRfHvr3SOLZ_45bTHdIMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/search.vue")
  },
  {
    name: accountYlzrdJAq4_u_45LRM6MHQPiDY8c1CgU1R7PJYr9v9srigMeta?.name,
    path: "/account",
    meta: accountYlzrdJAq4_u_45LRM6MHQPiDY8c1CgU1R7PJYr9v9srigMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account.vue"),
    children: [
  {
    name: ppvvAVPYxrfGfKT_45WnpuDmmVim38FlU6X7cVCd4pF94Bh8Meta?.name,
    path: "ppv",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/ppv.vue"),
    children: [
  {
    name: "account-ppv-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/ppv/[id].vue")
  },
  {
    name: "account-ppv",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/ppv/index.vue")
  }
]
  },
  {
    name: "account",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/index.vue")
  },
  {
    name: billingeme07d8f4Z5T74z7ymnIl7UrgrQA0iytrJQ1yW2ZAMcMeta?.name,
    path: "billing",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/billing.vue"),
    children: [
  {
    name: "account-billing",
    path: "",
    meta: indexDqGR35d5ohIPPWhipKyZNj_N6AaZZfuJLibx3cjUMwEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/billing/index.vue")
  }
]
  },
  {
    name: "account-devices",
    path: "devices",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/devices.vue")
  },
  {
    name: "account-general",
    path: "general",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/general.vue")
  },
  {
    name: "account-password",
    path: "password",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/password.vue")
  },
  {
    name: subscriptionGaly_MyYBxd8ZlSbz0VWyRDUHA_yFnaQhZyvev7NTVMMeta?.name,
    path: "subscription",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription.vue"),
    children: [
  {
    name: "account-subscription-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription/[id].vue")
  },
  {
    name: "account-subscription",
    path: "",
    meta: indexhfOCAmojLMGGnPtR_45_24kq6DDRaaMG_45XyjHQw_8coi4Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription/index.vue")
  },
  {
    name: "account-subscription-buy-id",
    path: "buy/:id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/account/subscription/buy/[id].vue")
  }
]
  }
]
  },
  {
    name: "archive",
    path: "/archive",
    meta: archiveybcfurk04AlrEfYkm7BoVT0ogvdtXMKHlXxv5Gc_arwMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/archive.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyhUUwT3SLt8vIFICF09gkn3ddlg3SZjy14WEyufeC08cMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/privacy.vue")
  },
  {
    name: "open-app",
    path: "/open-app",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/open-app.vue")
  },
  {
    name: "upcoming",
    path: "/upcoming",
    meta: upcomingI7y02yyAW5xxyWt_45KbLRNmtsxVEUO5ngwMi8jS4IYp8Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/upcoming.vue")
  },
  {
    name: "highlight",
    path: "/highlight",
    meta: highlighteQPkuUfZcw_45_iKs7HbXLgR_GAp8uZuK5WF58kCIEStkMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/highlight.vue")
  },
  {
    name: "suggested",
    path: "/suggested",
    meta: suggestedQWmMq3wjR4JCSDFiNAdbtnq6sYGg9nfsHZYdQs_45Vg40Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/suggested.vue")
  },
  {
    name: "live",
    path: "/live",
    meta: indexgGBIGDDpg_451KtId0IjG0xYgRwZX_Yt1_KCxtPeXfrIYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/live/index.vue")
  },
  {
    name: "info-type",
    path: "/info/:type()",
    meta: _91type_93yEk7ja_458HCmypghZ1z7BTXSY0oTF4Q_45iNdvEAt86E9UMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/info/[type].vue")
  },
  {
    name: "team-teamId",
    path: "/team/:teamId()",
    meta: _91teamId_93z2ALl1JeX_45RNAebB9QjkhHsX_45yvEaQ17_45tA_6YdSiOkMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/team/[teamId].vue")
  },
  {
    name: "recommendation",
    path: "/recommendation",
    meta: recommendationSUavnlMFHQSYvC9jpqi_45lDmVdaiXGV1e09tr5ssnNvwMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/recommendation.vue")
  },
  {
    name: "selected-clips",
    path: "/selected/clips",
    meta: clipsaQvFktAVHbhbmLSw50B5Ks2MPSPmJlzaNz53JXqM3sEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/selected/clips.vue")
  },
  {
    name: "following",
    path: "/following",
    meta: indexpaMUk_45DgGCHtOUn2puyhaveKwmrJ0XK18i0gWYM945EMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/index.vue")
  },
  {
    name: "payment-failure",
    path: "/payment/failure",
    meta: failureHXkteBEU8iKKgSmcqA_457H_yYDjSIdy_1KyFsAtrckpgMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/payment/failure.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    meta: successJckSAJ42KrsKQ32vQ1whAqn78EswcczFfrYTEpE0llYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/payment/success.vue")
  },
  {
    name: "selected-videos",
    path: "/selected/videos",
    meta: videosLvMruMnO3IMQl_Ik2pYlr1pNbPew7JPCtUl0d23xLVwMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/selected/videos.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexoHrmyWqiYOEgPg28IPhRSLUbzStIUTpNbzJXU0yxT1cMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/login/index.vue")
  },
  {
    name: "auth-login-limit",
    path: "/auth/login/limit",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/login/limit.vue")
  },
  {
    name: "events-eventId",
    path: "/events/:eventId()",
    meta: _91eventId_93Mh92EJ5mOR6mv2iUVg1aEgGvNlCe7jedPZJ87aw6wiwMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/events/[eventId].vue")
  },
  {
    name: _91sportType_93bps4msXZit4px08dk4UEwLmEo66W6OFEZmVeyDpLRFsMeta?.name,
    path: "/live/:sportType()",
    meta: _91sportType_93bps4msXZit4px08dk4UEwLmEo66W6OFEZmVeyDpLRFsMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/live/[sportType].vue"),
    children: [
  {
    name: "live-sportType",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/live/[sportType]/index.vue")
  }
]
  },
  {
    name: "league-leagueId",
    path: "/league/:leagueId()",
    meta: _91leagueId_93nWmEjZ78OM8lylJOl_7z5e0mOu_8zGd7DukBNyfg_453YMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/league/[leagueId].vue")
  },
  {
    name: "auth-sign-up",
    path: "/auth/sign-up",
    meta: indexVOj7fRgcKUOFog2k3O0iiJk29kkdglN8vyfUx_7NAi0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/index.vue")
  },
  {
    name: "channels-eventId",
    path: "/channels/:eventId()",
    meta: _91eventId_93fPANqZKisISQcg7mjavWM9Vd_FLHhu4_0V7emQhdR88Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/channels/[eventId].vue")
  },
  {
    name: "payment-processing",
    path: "/payment/processing",
    meta: processingpDMlBrQIdZsAN69rhFxswDUINYsHbZCUtDP5Q_wxaIcMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/payment/processing.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/password/reset.vue")
  },
  {
    name: "auth-password-forgot",
    path: "/auth/password/forgot",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/password/forgot.vue")
  },
  {
    name: "events-stats-eventId",
    path: "/events/stats/:eventId()",
    meta: _91eventId_93nQr68YgI3GB_45rveKU6UdBnm_45HVyfsVrNd3W7DjEMgCkMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/events/stats/[eventId].vue")
  },
  {
    name: "following-league",
    path: "/following/league",
    meta: indexXsPAzqpvZL50CPt_nwvRJnZbbxFMZjl66TBYLLtIdBoMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/index.vue")
  },
  {
    name: "category-mainId",
    path: "/category/:mainId()",
    meta: indexIwU9d9EwJsxWWYj6X9VarFpBpAgLDoVDPLZZX9w_45hcUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/category/[mainId]/index.vue")
  },
  {
    name: "following-category",
    path: "/following/category",
    meta: indexo5OZdZaJJxGmQ8FDJretkRlWUoaaNpXGeqS4f8IcktkMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/index.vue")
  },
  {
    name: "following-league-followed",
    path: "/following/league/followed",
    meta: followedfY3zva3fcFQSAWi5Izuubkzvf8bJtxcb2RbAhMWOmIIMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/followed.vue")
  },
  {
    name: "following-category-followed",
    path: "/following/category/followed",
    meta: followedydpfaSoypEQ_2_45AA9It3Srdq_453p9wGHK8BtQfnUgSHcMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/followed.vue")
  },
  {
    name: "auth-sign-up-personalization",
    path: "/auth/sign-up/personalization",
    meta: personalizationUTfceHIHg4y6NyknPI8OPEHcXRvldP3aoBz_QqjsbC0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/personalization.vue")
  },
  {
    name: "redirect-events-referenceId",
    path: "/redirect/events/:referenceId()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/redirect/events/[referenceId].vue")
  },
  {
    name: "auth-oauth2-callback-provider",
    path: "/auth/oauth2/callback/:provider()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/oauth2/callback/[provider].vue")
  },
  {
    name: "auth-sign-up-subscription",
    path: "/auth/sign-up/subscription",
    meta: indexOAiNOLumTdwx6jm26J5k1UgGDx0FAuWyVo9y8ErIATAMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/subscription/index.vue")
  },
  {
    name: "following-category-mainId",
    path: "/following/category/:mainId()",
    meta: indexEuV1SkeGDfouKtDEEWrY5WXAuhsPnJcFV6zhXXbMFxMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/[mainId]/index.vue")
  },
  {
    name: "following-league-leagueId",
    path: "/following/league/:leagueId()",
    meta: index8OMeNDb_45ldantlTDDKdnzhXx41g2jBy6xC4hh038bsAMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/[leagueId]/index.vue")
  },
  {
    name: "auth-sign-up-subscription-buy-id",
    path: "/auth/sign-up/subscription/buy/:id()",
    meta: _91id_93qvZMjgMVONvurtH7KRGNnhH7FYiHe6SdYBrxIy5ho1sMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/subscription/buy/[id].vue")
  },
  {
    name: "auth-sign-up-subscription-code",
    path: "/auth/sign-up/subscription/code",
    meta: indexhNublU9J_sInTYBqO4mUzEvT_KRvzwwMa_eCgWQMkrYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/auth/sign-up/subscription/code/index.vue")
  },
  {
    name: "following-category-mainId-followed",
    path: "/following/category/:mainId()/followed",
    meta: followedO9GwW6CyzTUjOXoJnucwKCqzk4AESlHAHJxHs4Jy7K8Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/category/[mainId]/followed.vue")
  },
  {
    name: "following-league-leagueId-followed",
    path: "/following/league/:leagueId()/followed",
    meta: followedMA7Sth5zBsD4VGmrH2x3oucOu8SNDluZya5x4u7TyfoMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/following/league/[leagueId]/followed.vue")
  },
  {
    name: "category-mainId-sub-category-subId",
    path: "/category/:mainId()/sub-category/:subId()",
    meta: _91subId_93aRCRBdrgekStpVNvf4OIjFD0q7ziHw8Ec05vIlxM7cYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/pages/category/[mainId]/sub-category/[subId].vue")
  }
]